import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { FilterOperator, FilterOperatorObject } from '../../types';

export interface FilterHeaderProps {
  fieldName: string;
  filterOperator: FilterOperator;
  availableOperators: FilterOperatorObject[];
  onFilterOperatorChange: (operator: FilterOperator) => void;
}

export const FilterHeader: React.FC<FilterHeaderProps> = ({
  fieldName,
  filterOperator,
  availableOperators,
  onFilterOperatorChange,
}) => {
  return (
    <div className="flex items-center justify-between gap-3 pb-2 border-b border-border px-3">
      <div className="flex items-center gap-2 flex-1">
        <span className="font-semibold text-xs text-foreground">
          {fieldName}
        </span>
      </div>
      <div className="flex-shrink-0">
        <Select value={filterOperator} onValueChange={onFilterOperatorChange}>
          <SelectTrigger className="w-auto">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {availableOperators.map(operator => (
              <SelectItem key={operator.value} value={operator.value}>
                {operator.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
